import React from 'react';
import { CalendarIcon, ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';
export function CTA() {
  const handleBookCall = () => {
    window.open('https://calendly.com', '_blank');
  };
  return <div className="py-24 bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-700 text-white relative overflow-hidden" data-id="element-13">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10" data-id="element-14">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-15"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-pink-300 rounded-full blur-3xl" data-id="element-16"></div>
      </div>
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-17">
        {/* Main headline */}
        <h2 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-18">
          Ready to Scale Your Revenue
          <span className="block text-yellow-200" data-id="element-19">with AI?</span>
        </h2>
        {/* Subheadline */}
        <p className="text-xl lg:text-2xl text-blue-100 mb-10 max-w-3xl mx-auto" data-id="element-20">
          Book a 30-minute strategy call. We'll show you exactly how AI can 3x
          your pipeline in the next 6 months.
        </p>
        {/* Benefits */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-10 text-left" data-id="element-21">
          <div className="flex items-start gap-3" data-id="element-22">
            <CheckCircle2Icon className="w-6 h-6 text-green-300 flex-shrink-0" data-id="element-23" />
            <div data-id="element-24">
              <div className="font-semibold" data-id="element-25">Free Strategy Session</div>
              <div className="text-sm text-blue-200" data-id="element-26">
                No obligation, just insights
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-27">
            <CheckCircle2Icon className="w-6 h-6 text-green-300 flex-shrink-0" data-id="element-28" />
            <div data-id="element-29">
              <div className="font-semibold" data-id="element-30">Custom Roadmap</div>
              <div className="text-sm text-blue-200" data-id="element-31">
                Tailored to your business
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-32">
            <CheckCircle2Icon className="w-6 h-6 text-green-300 flex-shrink-0" data-id="element-33" />
            <div data-id="element-34">
              <div className="font-semibold" data-id="element-35">ROI Projection</div>
              <div className="text-sm text-blue-200" data-id="element-36">
                See your potential returns
              </div>
            </div>
          </div>
        </div>
        {/* CTA Button */}
        <button onClick={handleBookCall} className="group bg-white text-blue-600 px-10 py-5 rounded-xl font-bold text-xl hover:bg-blue-50 transition-all shadow-2xl hover:shadow-3xl hover:scale-105 inline-flex items-center gap-3" data-id="element-37">
          <CalendarIcon className="w-6 h-6" data-id="element-38" />
          Book Your Strategy Call Now
          <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-39" />
        </button>
        {/* Trust indicators */}
        <div className="mt-10 flex flex-col sm:flex-row gap-6 justify-center items-center text-sm text-blue-200" data-id="element-40">
          <div className="flex items-center gap-2" data-id="element-41">
            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" data-id="element-42"></div>
            <span data-id="element-43">Spots filling fast</span>
          </div>
          <div data-id="element-44">•</div>
          <div data-id="element-45">Average response time: 2 hours</div>
          <div data-id="element-46">•</div>
          <div data-id="element-47">No credit card required</div>
        </div>
      </div>
    </div>;
}